import { AppMenu } from "./app-menu";
import { AppModule } from "./app-module";
import { Application } from "./application";
import { SystemField } from "./system-field";
import { User } from "./user";

export class Profile  extends SystemField{
     
    name?: string;
    is_active?: number;
    is_custom?: number;
    description?: string;
    company_id?: string;
    system_admin?:number;

    //relationship
    applications?:Application[];
    app_menus?:AppMenu[];
    app_modules?:AppModule[];
    users?:User[]; //child
}
